// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1nlqI","box":"WorkspacesBox_box__3Mw6V","node":"WorkspacesBox_node__3iZQz"};